/* product-hek-calculator.js — Prindal-Hout (v10)

   Nieuw t.o.v. v9:
   - heightOptions -> heightGroups: elke hoogte verschijnt 1x. Heeft een
     hoogte >1 rollengte, dan verschijnt na de hoogte-keuze een extra
     "Lengte per rol"-stap; bij precies 1 rollengte wordt die automatisch
     gekozen (geen extra stap zichtbaar).
   - Markup opgesplitst in .hek-calc__col-left (tekst/keuzes) en
     .hek-calc__col-right (de tekening) — CSS grid regelt de 2-koloms
     lay-out over de volle breedte.
   - 4 kernvragen krijgen de .hek-calc__label--section klasse (groter,
     Prindal-oranje).
   - "Extra ondersteuning"-tekst gecorrigeerd (komt uit Liquid t.supportLabel).
*/
window.PrindalHekCalc = (function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var EPS = 0.005;

  function money(cents) {
    return '\u20AC ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function init(rootId, dataScriptId) {
    var root = document.getElementById(rootId);
    var dataScript = document.getElementById(dataScriptId);
    if (!root || !dataScript) return;

    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Hek calc: kon data niet lezen', e);
      return;
    }
    var t = data.t || {};
    var heightGroups = data.heightGroups || [];
    if (!heightGroups.length) return;

    // Vind de groep + specifieke rol-optie die bij de huidige pagina-variant hoort.
    var activeGroup = heightGroups[0];
    var active = heightGroups[0].rollOptions[0];
    heightGroups.forEach(function (g) {
      g.rollOptions.forEach(function (r) {
        if (r.variantId === data.initialVariantId) { activeGroup = g; active = r; }
      });
    });

    // ---------------------------------------------------------------
    // Root-markup — 2 kolommen: tekst/keuzes links, tekening rechts.
    // ---------------------------------------------------------------
    root.innerHTML =
      '<div class="hek-calc__col-left">' +

      '<p class="hek-calc__title"></p>' +
      '<p class="hek-calc__intro"></p>' +

      '<div class="hek-calc__block">' +
        '<p class="hek-calc__label hek-calc__label--section" data-hc-height-label></p>' +
        '<div class="hek-calc__shape-toggle" data-hc-height-toggle></div>' +
      '</div>' +

      '<div class="hek-calc__block" data-hc-roll-block hidden>' +
        '<p class="hek-calc__label" data-hc-roll-label></p>' +
        '<div class="hek-calc__shape-toggle" data-hc-roll-toggle></div>' +
      '</div>' +

      '<div data-hc-after-height hidden>' +

      '<div class="hek-calc__block">' +
        '<p class="hek-calc__label hek-calc__label--section" data-hc-mode-label></p>' +
        '<div class="hek-calc__shape-toggle" data-hc-mode-toggle>' +
          '<button type="button" class="hek-calc__shape-btn is-active" data-mode="rechthoek"></button>' +
          '<button type="button" class="hek-calc__shape-btn" data-mode="vrije"></button>' +
          '<button type="button" class="hek-calc__shape-btn" data-mode="lopende"></button>' +
        '</div>' +
      '</div>' +

      '<div data-hc-mode-rechthoek class="hek-calc__block">' +
        '<div class="hek-calc__inline-fields">' +
          '<div class="hek-calc__field hek-calc__field--num"><label data-hc-rect-width-label></label><input type="number" min="0" step="0.1" data-hc-rect-width></div>' +
          '<div class="hek-calc__field hek-calc__field--num"><label data-hc-rect-length-label></label><input type="number" min="0" step="0.1" data-hc-rect-length></div>' +
        '</div>' +
      '</div>' +

      '<div data-hc-mode-vrije class="hek-calc__block" hidden>' +
        '<div class="hek-calc__row-header">' +
          '<span></span>' +
          '<span class="hek-calc__info-wrap">' +
            '<button type="button" class="hek-calc__info-btn" aria-label="' + (t.infoLabel || '') + '">i</button>' +
            '<span class="hek-calc__info-tooltip" data-hc-angle-help></span>' +
          '</span>' +
        '</div>' +
        '<table class="hek-calc__table"><thead><tr><th></th><th data-hc-th-length></th><th data-hc-th-angle></th><th></th></tr></thead>' +
        '<tbody data-hc-segments-list></tbody></table>' +
        '<div class="hek-calc__inline-fields">' +
          '<button type="button" class="hek-calc__add-segment-btn" data-hc-add-segment></button>' +
          '<button type="button" class="hek-calc__add-segment-btn" data-hc-close-loop></button>' +
        '</div>' +
      '</div>' +

      '<div data-hc-mode-lopende class="hek-calc__block" hidden>' +
        '<div class="hek-calc__inline-fields">' +
          '<div class="hek-calc__field hek-calc__field--num"><label data-hc-linear-length-label></label><input type="number" min="0" step="0.1" data-hc-linear-length></div>' +
        '</div>' +
        '<div class="hek-calc__field" data-hc-linear-corners-wrap hidden>' +
          '<label data-hc-corners-label></label>' +
          '<input type="number" min="0" step="1" value="0" data-hc-linear-corners style="width:90px;">' +
        '</div>' +
      '</div>' +

      '<div class="hek-calc__block" data-hc-poles-question hidden>' +
        '<p class="hek-calc__label hek-calc__label--section" data-hc-poles-label></p>' +
        '<div class="hek-calc__toggle" data-hc-poles-toggle>' +
          '<button type="button" class="hek-calc__toggle-btn" data-val="yes"></button>' +
          '<button type="button" class="hek-calc__toggle-btn is-active" data-val="no"></button>' +
        '</div>' +
      '</div>' +

      '<div data-hc-poles-extra hidden>' +

        '<div class="hek-calc__block">' +
          '<p class="hek-calc__label" data-hc-spacing-label></p>' +
          '<p class="hek-calc__advice-text" data-hc-spacing-advice hidden></p>' +
          '<div class="hek-calc__toggle" data-hc-spacing-toggle>' +
            '<button type="button" class="hek-calc__toggle-btn is-active" data-spacing="1.5"></button>' +
            '<button type="button" class="hek-calc__toggle-btn" data-spacing="2"></button>' +
          '</div>' +
        '</div>' +

        '<div class="hek-calc__block" data-hc-support-block>' +
          '<div class="hek-calc__row-header">' +
            '<p class="hek-calc__label" data-hc-support-label></p>' +
            '<span class="hek-calc__row-header-actions">' +
              '<span class="hek-calc__info-wrap">' +
                '<button type="button" class="hek-calc__info-btn" aria-label="' + (t.infoLabel || '') + '">i</button>' +
                '<span class="hek-calc__info-tooltip" data-hc-support-tooltip></span>' +
              '</span>' +
              '<a href="#" target="_blank" rel="noopener" class="hek-calc__instructions-link" data-hc-support-instructions hidden></a>' +
            '</span>' +
          '</div>' +
          '<div class="hek-calc__toggle" data-hc-support-toggle>' +
            '<button type="button" class="hek-calc__toggle-btn" data-val="yes"></button>' +
            '<button type="button" class="hek-calc__toggle-btn is-active" data-val="no"></button>' +
          '</div>' +
        '</div>' +

        '<div class="hek-calc__block" data-hc-gate-block hidden>' +
          '<p class="hek-calc__label hek-calc__label--section" data-hc-gate-label></p>' +
          '<div class="hek-calc__toggle" data-hc-gate-toggle>' +
            '<button type="button" class="hek-calc__toggle-btn" data-val="yes"></button>' +
            '<button type="button" class="hek-calc__toggle-btn is-active" data-val="no"></button>' +
          '</div>' +
          '<div data-hc-gate-fields hidden style="margin-top:10px;">' +
            '<div class="hek-calc__block">' +
              '<p class="hek-calc__label" data-hc-gate-type-label></p>' +
              '<div class="hek-calc__picture-choice" data-hc-gate-type-choice></div>' +
            '</div>' +
            '<div class="hek-calc__block" data-hc-gate-dimension-block hidden>' +
              '<p class="hek-calc__label" data-hc-gate-dimension-label></p>' +
              '<div class="hek-calc__shape-toggle" data-hc-gate-dimension-choice></div>' +
              '<p class="hek-calc__advice-text" data-hc-gate-dimension-single-note hidden></p>' +
            '</div>' +
            '<div class="hek-calc__block" data-hc-gate-position-block hidden>' +
              '<p class="hek-calc__label" data-hc-gate-visualize-label></p>' +
              '<div class="hek-calc__inline-fields">' +
                '<div class="hek-calc__field hek-calc__field--num">' +
                  '<label data-hc-gate-segment-label></label>' +
                  '<select data-hc-gate-segment></select>' +
                '</div>' +
                '<div class="hek-calc__field hek-calc__field--num">' +
                  '<label data-hc-gate-distance-label></label>' +
                  '<input type="number" min="0" step="0.1" data-hc-gate-distance>' +
                '</div>' +
              '</div>' +
              '<p class="hek-calc__advice-text" data-hc-gate-no-fit hidden></p>' +
            '</div>' +
            '<div class="hek-calc__block" data-hc-gate-post-block hidden>' +
              '<p class="hek-calc__label" data-hc-gate-post-label></p>' +
              '<div class="hek-calc__picture-choice" data-hc-gate-post-choice></div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +

      '<div class="hek-calc__results" data-hc-results hidden>' +
        '<div class="hek-calc__row-group" data-hc-breakdown></div>' +
        '<div class="hek-calc__row-group hek-calc__row-group--pro" data-hc-pro-breakdown hidden></div>' +
        '<button type="button" class="hek-calc__button" data-hc-add-to-cart disabled></button>' +
        '<p class="hek-calc__cart-msg" data-hc-cart-msg></p>' +
      '</div>' +

      '</div>' +
      '</div>' +

      '<div class="hek-calc__col-right">' +
        '<div data-hc-after-height-right hidden>' +
          '<div class="hek-calc__drawing" data-hc-drawing-wrap>' +
            '<svg viewBox="0 0 520 520" data-hc-drawing-svg>' +
              '<g data-hc-drawing-content></g>' +
              '<text x="260" y="508" text-anchor="middle" class="hek-calc__drawing-note" data-hc-drawing-note opacity="0"></text>' +
            '</svg>' +
          '</div>' +
        '</div>' +
      '</div>';

    // ---------------------------------------------------------------
    // Labels
    // ---------------------------------------------------------------
    root.querySelector('.hek-calc__title').textContent = t.title || '';
    root.querySelector('.hek-calc__intro').textContent = t.intro || '';
    root.querySelector('[data-hc-height-label]').textContent = t.heightLabel || '';
    root.querySelector('[data-hc-roll-label]').textContent = t.rollLengthLabel || '';
    root.querySelector('[data-hc-mode-label]').textContent = t.modeLabel || '';
    root.querySelector('[data-mode="rechthoek"]').textContent = t.modeRect || '';
    root.querySelector('[data-mode="vrije"]').textContent = t.modeFree || '';
    root.querySelector('[data-mode="lopende"]').textContent = t.modeLinear || '';
    root.querySelector('[data-hc-rect-width-label]').textContent = t.width || '';
    root.querySelector('[data-hc-rect-length-label]').textContent = t.lengthField || '';
    root.querySelector('[data-hc-th-length]').textContent = t.length || '';
    root.querySelector('[data-hc-th-angle]').textContent = t.angle || '';
    root.querySelector('[data-hc-angle-help]').textContent = t.angleHelp || '';
    root.querySelector('[data-hc-add-segment]').textContent = t.addSegment || '';
    root.querySelector('[data-hc-close-loop]').textContent = t.closeLoop || '';
    root.querySelector('[data-hc-linear-length-label]').textContent = t.linearLength || '';
    root.querySelector('[data-hc-corners-label]').textContent = t.cornersLabel || '';
    root.querySelector('[data-hc-poles-label]').textContent = t.polesLabel || '';
    root.querySelector('[data-hc-spacing-label]').textContent = t.spacingLabel || '';
    root.querySelector('[data-spacing="1.5"]').textContent = t.spacing15 || '1,5 m';
    root.querySelector('[data-spacing="2"]').textContent = t.spacing2 || '2 m';
    root.querySelector('[data-hc-support-label]').textContent = t.supportLabel || '';
    root.querySelector('[data-hc-gate-label]').textContent = t.gateLabel || '';
    root.querySelector('[data-hc-gate-type-label]').textContent = t.gateTypeLabel || '';
    root.querySelector('[data-hc-gate-dimension-label]').textContent = t.gateDimensionLabel || '';
    root.querySelector('[data-hc-gate-visualize-label]').textContent = t.gateVisualizeLabel || '';
    root.querySelector('[data-hc-gate-post-label]').textContent = t.gatePostLabel || '';
    root.querySelector('[data-hc-gate-segment-label]').textContent = t.gateSegmentLabel || '';
    root.querySelector('[data-hc-gate-distance-label]').textContent = t.gateDistanceLabel || '';
    root.querySelectorAll('[data-val="yes"]').forEach(function (b) { b.textContent = t.yes || 'Ja'; });
    root.querySelectorAll('[data-val="no"]').forEach(function (b) { b.textContent = t.no || 'Nee'; });
    var drawingNote = root.querySelector('[data-hc-drawing-note]');
    drawingNote.textContent = t.schematicNote || '';

    var supportBlockEl = root.querySelector('[data-hc-support-block]');
    if (!data.enableSupport) {
      supportBlockEl.hidden = true;
    } else {
      var supportTooltip = root.querySelector('[data-hc-support-tooltip]');
      var supportTooltipWrap = supportTooltip.closest('.hek-calc__info-tooltip');
      if (data.supportImage) {
        supportTooltip.innerHTML = '<img src="' + data.supportImage + '" alt="">';
      } else {
        supportTooltip.textContent = t.supportLabel || '';
      }
      if (supportTooltipWrap) {
        supportTooltipWrap.style.width = (data.supportImageWidth || 400) + 'px';
      }
      var supportInstructionsEl = root.querySelector('[data-hc-support-instructions]');
      if (data.supportInstructionsUrl) {
        supportInstructionsEl.href = data.supportInstructionsUrl;
        supportInstructionsEl.textContent = data.supportInstructionsLabel || 'Instructies';
        supportInstructionsEl.hidden = false;
      }
    }

    // ---------------------------------------------------------------
    // Element refs
    // ---------------------------------------------------------------
    var heightToggleEl = root.querySelector('[data-hc-height-toggle]');
    var rollBlockEl = root.querySelector('[data-hc-roll-block]');
    var rollToggleEl = root.querySelector('[data-hc-roll-toggle]');
    var afterHeightEl = root.querySelector('[data-hc-after-height]');
    var afterHeightRightEl = root.querySelector('[data-hc-after-height-right]');
    var modeButtons = root.querySelectorAll('[data-hc-mode-toggle] [data-mode]');
    var modeRechthoekEl = root.querySelector('[data-hc-mode-rechthoek]');
    var modeVrijeEl = root.querySelector('[data-hc-mode-vrije]');
    var modeLopendeEl = root.querySelector('[data-hc-mode-lopende]');

    var rectWidthInput = root.querySelector('[data-hc-rect-width]');
    var rectLengthInput = root.querySelector('[data-hc-rect-length]');

    var segmentsList = root.querySelector('[data-hc-segments-list]');
    var addSegmentBtn = root.querySelector('[data-hc-add-segment]');
    var closeLoopBtn = root.querySelector('[data-hc-close-loop]');
    var closeLoopOn = false;

    var linearLengthInput = root.querySelector('[data-hc-linear-length]');
    var linearCornersWrap = root.querySelector('[data-hc-linear-corners-wrap]');
    var linearCornersInput = root.querySelector('[data-hc-linear-corners]');

    var drawingWrap = root.querySelector('[data-hc-drawing-wrap]');
    var drawingContent = root.querySelector('[data-hc-drawing-content]');

    var polesQuestion = root.querySelector('[data-hc-poles-question]');
    var polesToggleButtons = root.querySelectorAll('[data-hc-poles-toggle] [data-val]');
    var polesExtra = root.querySelector('[data-hc-poles-extra]');
    var spacingAdviceEl = root.querySelector('[data-hc-spacing-advice]');
    var spacingToggleButtons = root.querySelectorAll('[data-hc-spacing-toggle] [data-spacing]');
    var supportToggleButtons = root.querySelectorAll('[data-hc-support-toggle] [data-val]');
    var gateBlock = root.querySelector('[data-hc-gate-block]');
    var gateToggleButtons = root.querySelectorAll('[data-hc-gate-toggle] [data-val]');
    var gateFields = root.querySelector('[data-hc-gate-fields]');
    var gateTypeChoiceEl = root.querySelector('[data-hc-gate-type-choice]');
    var gateDimensionBlock = root.querySelector('[data-hc-gate-dimension-block]');
    var gateDimensionChoiceEl = root.querySelector('[data-hc-gate-dimension-choice]');
    var gateDimensionSingleNoteEl = root.querySelector('[data-hc-gate-dimension-single-note]');
    var gatePositionBlock = root.querySelector('[data-hc-gate-position-block]');
    var gateSegmentSelect = root.querySelector('[data-hc-gate-segment]');
    var gateDistanceInput = root.querySelector('[data-hc-gate-distance]');
    var gateNoFitEl = root.querySelector('[data-hc-gate-no-fit]');
    var gatePostBlock = root.querySelector('[data-hc-gate-post-block]');
    var gatePostChoiceEl = root.querySelector('[data-hc-gate-post-choice]');

    var resultsEl = root.querySelector('[data-hc-results]');
    var breakdownEl = root.querySelector('[data-hc-breakdown]');
    var proBreakdownEl = root.querySelector('[data-hc-pro-breakdown]');
    var addToCartBtn = root.querySelector('[data-hc-add-to-cart]');
    addToCartBtn.textContent = t.addToCart || '';
    var cartMsg = root.querySelector('[data-hc-cart-msg]');

    // ---------------------------------------------------------------
    // State
    // ---------------------------------------------------------------
    var state = {
      mode: 'rechthoek', polesOn: false, spacing: 1.5, supportOn: false,
      gateOn: false, gateType: null, gateItem: null, gatePost: null,
      gateSegIdx: 0, gateDist: 0
    };
    var segments = [];
    var segIdCounter = 0;
    var lastCalc = null;

    // ---------------------------------------------------------------
    // Zodra hoogte + (indien nodig) rollengte gekend zijn: de rest van
    // de calculator tonen (links en rechts) en initialiseren.
    // ---------------------------------------------------------------
    function revealAfterHeight() {
      afterHeightEl.hidden = false;
      afterHeightRightEl.hidden = false;
      updateSpacingAdvice();
      rebuildGateChoices();
      recalc();
    }

    function selectRollOption(opt) {
      active = opt;
      revealAfterHeight();
    }

    function rebuildRollChoices(group) {
      rollToggleEl.innerHTML = '';
      if (group.rollOptions.length <= 1) {
        rollBlockEl.hidden = true;
        selectRollOption(group.rollOptions[0]);
        return;
      }
      rollBlockEl.hidden = false;
      afterHeightEl.hidden = true;
      afterHeightRightEl.hidden = true;
      var btns = [];
      group.rollOptions.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hek-calc__shape-btn';
        var lenStr = String(opt.rollLengthM).replace('.', ',');
        btn.textContent = lenStr + ' m';
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          selectRollOption(opt);
        });
        btns.push(btn);
        rollToggleEl.appendChild(btn);
      });
    }

    // ---------------------------------------------------------------
    // Hoogte-keuze — niets eronder verschijnt tot de klant expliciet
    // op een hoogte klikt (en, indien van toepassing, een rollengte).
    // ---------------------------------------------------------------
    heightGroups.forEach(function (g) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hek-calc__shape-btn';
      btn.textContent = g.heightLabel;
      btn.addEventListener('click', function () {
        activeGroup = g;
        heightToggleEl.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        rebuildRollChoices(g);
      });
      heightToggleEl.appendChild(btn);
    });

    function updateSpacingAdvice() {
      if (active.recommendedSpacingM) {
        var valStr = String(active.recommendedSpacingM).replace('.', ',');
        spacingAdviceEl.textContent = (t.spacingAdviceTemplate || '').replace('{value}', valStr);
        spacingAdviceEl.hidden = false;
      } else {
        spacingAdviceEl.hidden = true;
      }
    }

    // ---------------------------------------------------------------
    // Poort: type-keuze als mooie beeldkaarten, daarna afmeting-keuze
    // als tekstknoppen (varianttitel), daarna plaatsing (zijde+afstand
    // met live tekening), en PAS DAARNA de paal-materiaal-keuze.
    // ---------------------------------------------------------------
    function buildPictureCard(container, key, imgSrc, label, widthPx, onSelect) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hek-calc__picture-card';
      btn.setAttribute('data-key', key);
      btn.style.width = widthPx + 'px';
      btn.innerHTML = (imgSrc ? '<img src="' + imgSrc + '" alt="">' : '') + '<span class="hek-calc__picture-card__label">' + label + '</span>';
      btn.addEventListener('click', onSelect);
      container.appendChild(btn);
      return btn;
    }

    function rebuildGateChoices() {
      gateTypeChoiceEl.innerHTML = '';
      var typeBtns = [];
      var poortWidth = data.poortImageWidth || 260;

      if (active.hasPoortEnkel) {
        typeBtns.push(buildPictureCard(gateTypeChoiceEl, 'enkel', data.poortEnkelImage, t.gateSingle || 'Enkel', poortWidth, function () {
          state.gateType = 'enkel';
          state.gateItem = null;
          typeBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-key') === 'enkel'); });
          rebuildGateDimensionChoices();
          recalc();
        }));
      }
      if (active.hasPoortDubbel) {
        typeBtns.push(buildPictureCard(gateTypeChoiceEl, 'dubbel', data.poortDubbelImage, t.gateDouble || 'Dubbel', poortWidth, function () {
          state.gateType = 'dubbel';
          state.gateItem = null;
          typeBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-key') === 'dubbel'); });
          rebuildGateDimensionChoices();
          recalc();
        }));
      }
      if (state.gateType === 'enkel' && !active.hasPoortEnkel) { state.gateType = null; state.gateItem = null; }
      if (state.gateType === 'dubbel' && !active.hasPoortDubbel) { state.gateType = null; state.gateItem = null; }
      typeBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-key') === state.gateType); });
      rebuildGateDimensionChoices();

      gatePostChoiceEl.innerHTML = '';
      var postBtns = [];
      var paalWidth = data.paalImageWidth || 260;
      if (active.hasPaalEik) {
        postBtns.push(buildPictureCard(gatePostChoiceEl, 'eik', data.paalEikImage, t.gatePostOak || 'Eik', paalWidth, function () {
          state.gatePost = 'eik';
          postBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-key') === 'eik'); });
          recalc();
        }));
      }
      if (active.hasPaalKastanje) {
        postBtns.push(buildPictureCard(gatePostChoiceEl, 'kastanje', data.paalKastanjeImage, t.gatePostChestnut || 'Kastanje', paalWidth, function () {
          state.gatePost = 'kastanje';
          postBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-key') === 'kastanje'); });
          recalc();
        }));
      }
      if (state.gatePost === 'eik' && !active.hasPaalEik) state.gatePost = null;
      if (state.gatePost === 'kastanje' && !active.hasPaalKastanje) state.gatePost = null;
      postBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-key') === state.gatePost); });

      var poortAvailable = active.hasPoortEnkel || active.hasPoortDubbel;
      gateBlock.hidden = !(state.polesOn && poortAvailable);
    }

    function rebuildGateDimensionChoices() {
      gateDimensionChoiceEl.innerHTML = '';
      gateDimensionSingleNoteEl.hidden = true;
      if (!state.gateType) {
        gateDimensionBlock.hidden = true;
        gatePositionBlock.hidden = true;
        updateGatePostVisibility();
        return;
      }
      var options = state.gateType === 'dubbel' ? (active.poortDubbelOptions || []) : (active.poortEnkelOptions || []);
      if (!options.length) {
        gateDimensionBlock.hidden = true;
        gatePositionBlock.hidden = true;
        updateGatePostVisibility();
        return;
      }

      if (options.length === 1) {
        // Slechts 1 afmeting beschikbaar: automatisch kiezen, maar wel
        // zichtbaar tonen welke — anders ziet de klant dit nergens tot
        // de eindafrekening.
        state.gateItem = options[0];
        gateDimensionBlock.hidden = false;
        gateDimensionChoiceEl.hidden = true;
        gateDimensionSingleNoteEl.textContent = (t.gateDimensionSingleTemplate || '').replace('{value}', options[0].title);
        gateDimensionSingleNoteEl.hidden = false;
        refreshGateSegmentOptions();
        return;
      }

      gateDimensionChoiceEl.hidden = false;
      gateDimensionBlock.hidden = false;
      var btns = [];
      options.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hek-calc__shape-btn';
        btn.textContent = opt.title;
        btn.addEventListener('click', function () {
          state.gateItem = opt;
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          refreshGateSegmentOptions();
          recalc();
        });
        if (state.gateItem && state.gateItem.variantId === opt.variantId) btn.classList.add('is-active');
        btns.push(btn);
        gateDimensionChoiceEl.appendChild(btn);
      });
    }

    // ---------------------------------------------------------------
    // Poort-plaatsing: welke zijde + op welke afstand vanaf het begin
    // van die zijde. Enkel zijden die lang genoeg zijn voor de gekozen
    // poortbreedte worden aangeboden. De paal-materiaal-keuze (eik/
    // kastanje) blijft verborgen tot hier een geldige plaatsing uit komt.
    // ---------------------------------------------------------------
    function getGateWidthM() {
      if (!state.gateItem || !state.gateItem.widthCm) return 0;
      return state.gateItem.widthCm / 100;
    }

    function hasValidGatePlacement() {
      var widthM = getGateWidthM();
      if (state.mode === 'lopende' || !widthM) return false;
      var segs = getEffectiveSegments();
      var seg = segs.list[state.gateSegIdx];
      return !!(seg && seg.lengthM >= widthM - EPS);
    }

    function updateGatePostVisibility() {
      gatePostBlock.hidden = !hasValidGatePlacement();
    }

    function refreshGateSegmentOptions() {
      var widthM = getGateWidthM();
      if (state.mode === 'lopende' || !widthM) {
        gatePositionBlock.hidden = true;
        updateGatePostVisibility();
        return;
      }
      var segs = getEffectiveSegments();
      gateSegmentSelect.innerHTML = '';
      var validIdx = [];
      segs.list.forEach(function (s, i) {
        var fits = s.lengthM >= widthM - EPS;
        var opt = document.createElement('option');
        opt.value = i;
        opt.textContent = (t.segment || 'Segment') + ' ' + (i + 1) + ' (' + s.lengthM.toFixed(1) + ' m)';
        opt.disabled = !fits;
        gateSegmentSelect.appendChild(opt);
        if (fits) validIdx.push(i);
      });

      if (!validIdx.length) {
        gatePositionBlock.hidden = false;
        gateSegmentSelect.hidden = true;
        gateDistanceInput.closest('.hek-calc__field').hidden = true;
        gateNoFitEl.textContent = t.gateNoFit || '';
        gateNoFitEl.hidden = false;
        updateGatePostVisibility();
        return;
      }

      gatePositionBlock.hidden = false;
      gateSegmentSelect.hidden = false;
      gateDistanceInput.closest('.hek-calc__field').hidden = false;
      gateNoFitEl.hidden = true;

      if (validIdx.indexOf(state.gateSegIdx) === -1) state.gateSegIdx = validIdx[0];
      gateSegmentSelect.value = state.gateSegIdx;
      clampGateDistance();
      updateGatePostVisibility();
    }

    function clampGateDistance() {
      var segs = getEffectiveSegments();
      var seg = segs.list[state.gateSegIdx];
      var widthM = getGateWidthM();
      if (!seg || !widthM) return;
      var maxDist = Math.max(0, seg.lengthM - widthM);
      if (state.gateDist > maxDist) state.gateDist = maxDist;
      if (state.gateDist < 0) state.gateDist = 0;
      gateDistanceInput.max = maxDist.toFixed(2);
      gateDistanceInput.value = state.gateDist;
    }

    gateSegmentSelect.addEventListener('change', function () {
      state.gateSegIdx = parseInt(gateSegmentSelect.value, 10) || 0;
      clampGateDistance();
      updateGatePostVisibility();
      recalc();
    });
    gateDistanceInput.addEventListener('input', function () {
      state.gateDist = parseFloat(gateDistanceInput.value) || 0;
      clampGateDistance();
      updateGatePostVisibility();
      recalc();
    });

    // ---------------------------------------------------------------
    // Vrije-vorm segmenten
    // ---------------------------------------------------------------
    function addSegment() {
      segIdCounter++;
      var isFirst = segments.length === 0;
      var tr = document.createElement('tr');
      tr.innerHTML =
        '<td class="hek-calc__seg-name"></td>' +
        '<td><input type="number" min="0" step="0.1" inputmode="decimal" data-seg-length></td>' +
        '<td><input type="number" step="1" inputmode="decimal" data-seg-angle value="' + (isFirst ? '0' : '90') + '"' + (isFirst ? ' disabled' : '') + '></td>' +
        '<td><button type="button" class="hek-calc__seg-remove">\u00D7</button></td>';
      segmentsList.appendChild(tr);

      var seg = {
        id: segIdCounter, rowEl: tr,
        nameEl: tr.querySelector('.hek-calc__seg-name'),
        lengthInput: tr.querySelector('[data-seg-length]'),
        angleInput: tr.querySelector('[data-seg-angle]'),
        removeBtn: tr.querySelector('.hek-calc__seg-remove')
      };
      seg.removeBtn.setAttribute('aria-label', t.removeSegment || '');
      seg.lengthInput.addEventListener('input', function () { refreshGateSegmentOptions(); recalc(); });
      seg.angleInput.addEventListener('input', recalc);
      seg.removeBtn.addEventListener('click', function () { removeSegment(seg); });

      segments.push(seg);
      renumberSegments();
      return seg;
    }
    function removeSegment(seg) {
      if (segments.length <= 1) return;
      var idx = segments.indexOf(seg);
      segments.splice(idx, 1);
      seg.rowEl.parentNode.removeChild(seg.rowEl);
      if (segments.length) { segments[0].angleInput.value = '0'; segments[0].angleInput.disabled = true; }
      renumberSegments();
      refreshGateSegmentOptions();
      recalc();
    }
    function renumberSegments() {
      segments.forEach(function (s, i) {
        s.nameEl.textContent = (t.segment || 'Segment') + ' ' + (i + 1);
        s.removeBtn.hidden = segments.length <= 1;
      });
    }
    addSegmentBtn.addEventListener('click', function () { addSegment(); refreshGateSegmentOptions(); recalc(); });
    closeLoopBtn.addEventListener('click', function () {
      closeLoopOn = !closeLoopOn;
      closeLoopBtn.classList.toggle('is-active', closeLoopOn);
      refreshGateSegmentOptions();
      recalc();
    });

    // ---------------------------------------------------------------
    // Mode-toggle
    // ---------------------------------------------------------------
    modeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.getAttribute('data-mode');
        modeButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        modeRechthoekEl.hidden = state.mode !== 'rechthoek';
        modeVrijeEl.hidden = state.mode !== 'vrije';
        modeLopendeEl.hidden = state.mode !== 'lopende';
        drawingWrap.hidden = state.mode === 'lopende';
        linearCornersWrap.hidden = !(state.polesOn && state.mode === 'lopende');
        if (state.mode === 'vrije' && segments.length === 0) addSegment();
        refreshGateSegmentOptions();
        recalc();
      });
    });
    rectWidthInput.addEventListener('input', function () { refreshGateSegmentOptions(); recalc(); });
    rectLengthInput.addEventListener('input', function () { refreshGateSegmentOptions(); recalc(); });
    linearLengthInput.addEventListener('input', recalc);
    linearCornersInput.addEventListener('input', recalc);

    // ---------------------------------------------------------------
    // Palen / tussenafstand / support / poort
    // ---------------------------------------------------------------
    polesToggleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.polesOn = btn.getAttribute('data-val') === 'yes';
        polesToggleButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        polesExtra.hidden = !state.polesOn;
        linearCornersWrap.hidden = !(state.polesOn && state.mode === 'lopende');
        rebuildGateChoices();
        recalc();
      });
    });
    spacingToggleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.spacing = parseFloat(btn.getAttribute('data-spacing'));
        spacingToggleButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        recalc();
      });
    });
    supportToggleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.supportOn = btn.getAttribute('data-val') === 'yes';
        supportToggleButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        recalc();
      });
    });
    gateToggleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.gateOn = btn.getAttribute('data-val') === 'yes';
        gateToggleButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        gateFields.hidden = !state.gateOn;
        recalc();
      });
    });

    // ---------------------------------------------------------------
    // Geometrie
    // ---------------------------------------------------------------
    function walkPoints(list) {
      var heading = 0;
      var pts = [{ x: 0, y: 0 }];
      list.forEach(function (seg, i) {
        if (i > 0) heading += (seg.angleDeg * Math.PI) / 180;
        var last = pts[pts.length - 1];
        pts.push({ x: last.x + seg.lengthM * Math.cos(heading), y: last.y + seg.lengthM * Math.sin(heading) });
      });
      return { pts: pts, endHeading: heading };
    }

    function computeClosingSegment(list) {
      if (!list.length) return null;
      var walked = walkPoints(list);
      var last = walked.pts[walked.pts.length - 1];
      var dx = -last.x, dy = -last.y;
      var dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < EPS) return null;
      var targetHeading = Math.atan2(dy, dx);
      var turnDeg = (targetHeading - walked.endHeading) * 180 / Math.PI;
      while (turnDeg > 180) turnDeg -= 360;
      while (turnDeg < -180) turnDeg += 360;
      return { lengthM: dist, angleDeg: turnDeg };
    }

    function getEffectiveSegments() {
      if (state.mode === 'rechthoek') {
        var w = parseFloat(rectWidthInput.value) || 0;
        var l = parseFloat(rectLengthInput.value) || 0;
        if (w <= 0 || l <= 0) return { list: [], closed: true };
        return { list: [{ lengthM: w, angleDeg: 0 }, { lengthM: l, angleDeg: 90 }, { lengthM: w, angleDeg: 90 }, { lengthM: l, angleDeg: 90 }], closed: true };
      }
      if (state.mode === 'vrije') {
        var list = segments
          .map(function (s, i) { return { lengthM: parseFloat(s.lengthInput.value) || 0, angleDeg: i === 0 ? 0 : (parseFloat(s.angleInput.value) || 0) }; })
          .filter(function (s) { return s.lengthM > 0; });
        if (closeLoopOn && list.length) {
          var closer = computeClosingSegment(list);
          if (closer) list = list.concat([closer]);
        }
        return { list: list, closed: closeLoopOn };
      }
      return { list: [], closed: false };
    }

    // ---------------------------------------------------------------
    // Poort-plaatsing berekenen: welk stuk, welke afstand, hoeveel er
    // vóór en na de poort overblijft op dat ene stuk. Vereist NIET meer
    // dat er al een paal-materiaal gekozen is — dat is enkel nodig voor
    // de PRIJS van de 2 palen, niet voor de plaatsing/tekening zelf.
    // ---------------------------------------------------------------
    function computeGatePlacement(segList, closed) {
      if (!state.polesOn || !state.gateOn || !state.gateType || !state.gateItem) return null;
      var n = segList.length;
      if (!n) return null;
      var widthM = getGateWidthM();
      if (!widthM || widthM <= 0) return null;

      var segIdx = Math.min(state.gateSegIdx, n - 1);
      var seg = segList[segIdx];
      if (!seg || seg.lengthM < widthM - EPS) return null; // past niet op dit stuk

      var maxDist = Math.max(0, seg.lengthM - widthM);
      var distStart = Math.max(0, Math.min(state.gateDist || 0, maxDist));
      var distEnd = distStart + widthM;

      var absorbStart = distStart <= EPS;
      var absorbEnd = (seg.lengthM - distEnd) <= EPS;
      var pieceA = absorbStart ? 0 : distStart;
      var pieceB = absorbEnd ? 0 : (seg.lengthM - distEnd);
      var startVertex = segIdx;
      var endVertex = closed ? (segIdx + 1) % n : segIdx + 1;

      return {
        segIdx: segIdx, widthM: widthM, distStart: distStart, distEnd: distEnd,
        absorbStart: absorbStart, absorbEnd: absorbEnd, pieceA: pieceA, pieceB: pieceB,
        startVertex: startVertex, endVertex: endVertex
      };
    }

    // ---------------------------------------------------------------
    // Palenrekenwerk (rechthoek/vrije vorm). Als er een poort actief is
    // op een stuk, wordt dat ene stuk gesplitst in pieceA/pieceB (elk
    // met hun eigen onafhankelijke tussenpaal-telling), en telt de
    // poortbreedte niet mee als hekwerk-lengte.
    // ---------------------------------------------------------------
    function computePolesForSegments(segList, closed, spacing, gatePlacement) {
      if (!segList.length) return { hoekpalen: 0, tussenpalen: 0, totalLength: 0 };
      var n = segList.length;
      var vertexCount = closed ? n : n + 1;

      var absorbed = {};
      if (gatePlacement) {
        if (gatePlacement.absorbStart) absorbed[gatePlacement.startVertex] = true;
        if (gatePlacement.absorbEnd) absorbed[gatePlacement.endVertex] = true;
      }
      var hoekpalen = vertexCount - Object.keys(absorbed).length;

      var tussenpalen = 0;
      segList.forEach(function (s, i) {
        if (gatePlacement && i === gatePlacement.segIdx) {
          [gatePlacement.pieceA, gatePlacement.pieceB].forEach(function (len) {
            if (len <= EPS) return;
            var intervals = Math.ceil((len - EPS) / spacing);
            tussenpalen += Math.max(0, intervals - 1);
          });
        } else {
          if (s.lengthM <= EPS) return;
          var intervals2 = Math.ceil((s.lengthM - EPS) / spacing);
          tussenpalen += Math.max(0, intervals2 - 1);
        }
      });

      var totalLength = segList.reduce(function (s, seg) { return s + seg.lengthM; }, 0);
      if (gatePlacement) totalLength -= gatePlacement.widthM;

      return { hoekpalen: hoekpalen, tussenpalen: tussenpalen, totalLength: totalLength };
    }

    // ---------------------------------------------------------------
    // Tekening
    // ---------------------------------------------------------------
    function drawFence(segList, closed, gatePlacement) {
      drawingContent.innerHTML = '';
      if (!segList.length) { drawingNote.setAttribute('opacity', '0'); return; }

      var pts = walkPoints(segList).pts;
      var viewW = 520, viewH = 520, pad = 65;
      var xs = pts.map(function (p) { return p.x; }), ys = pts.map(function (p) { return p.y; });
      var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
      var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
      var spanX = Math.max(maxX - minX, 0.01), spanY = Math.max(maxY - minY, 0.01);
      var scale = Math.min((viewW - pad * 2) / spanX, (viewH - pad * 2) / spanY);
      var offsetX = pad + (viewW - pad * 2 - spanX * scale) / 2 - minX * scale;
      var offsetY = pad + (viewH - pad * 2 - spanY * scale) / 2 - minY * scale;
      function toSvg(p) { return { x: p.x * scale + offsetX, y: p.y * scale + offsetY }; }
      function lerp(a, b, frac) { return { x: a.x + (b.x - a.x) * frac, y: a.y + (b.y - a.y) * frac }; }

      function drawSpan(aModel, bModel, lenM, showLabel) {
        var a = toSvg(aModel), b = toSvg(bModel);
        var line = document.createElementNS(SVG_NS, 'line');
        line.setAttribute('x1', a.x); line.setAttribute('y1', a.y);
        line.setAttribute('x2', b.x); line.setAttribute('y2', b.y);
        line.setAttribute('stroke', '#e87722'); line.setAttribute('stroke-width', '3');
        drawingContent.appendChild(line);

        var dx = b.x - a.x, dy = b.y - a.y, len = Math.sqrt(dx * dx + dy * dy) || 1;
        if (showLabel) {
          var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
          var nx = -dy / len, ny = dx / len;
          var label = document.createElementNS(SVG_NS, 'text');
          label.setAttribute('x', mx + nx * 12); label.setAttribute('y', my + ny * 12);
          label.setAttribute('text-anchor', 'middle'); label.setAttribute('font-size', '11'); label.setAttribute('fill', '#444');
          label.textContent = (Math.round(lenM * 100) / 100) + ' m';
          drawingContent.appendChild(label);
        }

        if (state.polesOn && lenM > EPS) {
          var intervals = Math.ceil((lenM - EPS) / state.spacing);
          var tussenCount = Math.max(0, intervals - 1);
          for (var k = 1; k <= tussenCount; k++) {
            var frac = k / (tussenCount + 1);
            var xx = a.x + dx * frac, yy = a.y + dy * frac;
            var xmark = document.createElementNS(SVG_NS, 'text');
            xmark.setAttribute('x', xx); xmark.setAttribute('y', yy + 4);
            xmark.setAttribute('text-anchor', 'middle'); xmark.setAttribute('font-size', '11'); xmark.setAttribute('fill', '#3a9b3a');
            xmark.textContent = '\u00D7';
            drawingContent.appendChild(xmark);
          }
        }
      }

      function drawGateZone(startSvg, endSvg) {
        var rect = document.createElementNS(SVG_NS, 'line');
        rect.setAttribute('x1', startSvg.x); rect.setAttribute('y1', startSvg.y);
        rect.setAttribute('x2', endSvg.x); rect.setAttribute('y2', endSvg.y);
        rect.setAttribute('stroke', '#2d2d2d'); rect.setAttribute('stroke-width', '5'); rect.setAttribute('stroke-dasharray', '2 3');
        drawingContent.appendChild(rect);
        var mx = (startSvg.x + endSvg.x) / 2, my = (startSvg.y + endSvg.y) / 2;
        var lbl = document.createElementNS(SVG_NS, 'text');
        lbl.setAttribute('x', mx); lbl.setAttribute('y', my - 10);
        lbl.setAttribute('text-anchor', 'middle'); lbl.setAttribute('font-size', '10'); lbl.setAttribute('font-weight', '700'); lbl.setAttribute('fill', '#2d2d2d');
        lbl.textContent = t.gateLineLabel || 'Poort';
        drawingContent.appendChild(lbl);
      }

      function drawPostMarker(sp) {
        var sq = document.createElementNS(SVG_NS, 'rect');
        sq.setAttribute('x', sp.x - 5); sq.setAttribute('y', sp.y - 5);
        sq.setAttribute('width', 10); sq.setAttribute('height', 10);
        sq.setAttribute('fill', '#2d2d2d'); sq.setAttribute('stroke', '#2d2d2d'); sq.setAttribute('stroke-width', '1');
        drawingContent.appendChild(sq);
      }

      var skipVertexCircle = {};

      for (var i = 0; i < pts.length - 1; i++) {
        var aModel = pts[i], bModel = pts[i + 1];
        var segLenM = segList[i].lengthM;

        if (gatePlacement && gatePlacement.segIdx === i) {
          var fracStart = gatePlacement.distStart / segLenM;
          var fracEnd = gatePlacement.distEnd / segLenM;
          var gateStartModel = lerp(aModel, bModel, fracStart);
          var gateEndModel = lerp(aModel, bModel, fracEnd);

          if (gatePlacement.pieceA > EPS) drawSpan(aModel, gateStartModel, gatePlacement.pieceA, true);
          drawGateZone(toSvg(gateStartModel), toSvg(gateEndModel));
          if (gatePlacement.pieceB > EPS) drawSpan(gateEndModel, bModel, gatePlacement.pieceB, true);

          drawPostMarker(toSvg(gateStartModel));
          drawPostMarker(toSvg(gateEndModel));

          if (gatePlacement.absorbStart) skipVertexCircle[gatePlacement.startVertex] = true;
          if (gatePlacement.absorbEnd) skipVertexCircle[gatePlacement.endVertex] = true;
        } else {
          drawSpan(aModel, bModel, segLenM, true);
        }
      }

      pts.forEach(function (p, i) {
        if (closed && i === pts.length - 1) return;
        if (skipVertexCircle[i]) return;
        var sp = toSvg(p);
        var isTrueEnd = !closed && (i === 0 || i === pts.length - 1);
        var circle = document.createElementNS(SVG_NS, 'circle');
        circle.setAttribute('cx', sp.x); circle.setAttribute('cy', sp.y);
        circle.setAttribute('r', isTrueEnd ? 6 : 4.5);
        circle.setAttribute('fill', isTrueEnd ? '#e87722' : '#fff');
        circle.setAttribute('stroke', isTrueEnd ? '#e87722' : '#7CB139');
        circle.setAttribute('stroke-width', '2');
        drawingContent.appendChild(circle);
        if (isTrueEnd) {
          var lbl = document.createElementNS(SVG_NS, 'text');
          lbl.setAttribute('x', sp.x); lbl.setAttribute('y', sp.y - 12);
          lbl.setAttribute('text-anchor', 'middle'); lbl.setAttribute('font-size', '10'); lbl.setAttribute('font-weight', '700'); lbl.setAttribute('fill', '#e87722');
          lbl.textContent = i === 0 ? (t.begin || 'Begin') : (t.end || 'Eind');
          drawingContent.appendChild(lbl);
        }
      });

      drawingNote.setAttribute('opacity', '1');
    }

    // ---------------------------------------------------------------
    // Aannemer-prijs sync — haalt het echte product op en zet het
    // resultaat in de LEVENDE DOM (verborgen, off-screen) zodat WPD's
    // eigen script het effectief kan vinden en invullen. Scripts uit de
    // opgehaalde HTML worden manueel opnieuw aangemaakt, want scripts
    // die via innerHTML worden toegevoegd voeren zichzelf niet uit.
    // ---------------------------------------------------------------
    var proPriceCache = {};
    var proSyncPending = {};
    var proSyncQueue = [];
    var proSyncInFlight = false;
    var proSyncContainer = null;

    function getProSyncContainer() {
      if (!proSyncContainer) {
        proSyncContainer = document.createElement('div');
        proSyncContainer.setAttribute('aria-hidden', 'true');
        proSyncContainer.style.cssText = 'position:absolute; width:1px; height:1px; overflow:hidden; clip:rect(0,0,0,0); left:-9999px; top:0;';
        document.body.appendChild(proSyncContainer);
      }
      return proSyncContainer;
    }

    function requestProSync(item) {
      if (!item || !item.variantId || !item.productUrl || !item.productId) return;
      if (proPriceCache[item.variantId] != null) return;
      if (proSyncPending[item.variantId]) return;
      proSyncPending[item.variantId] = true;
      proSyncQueue.push(item);
      processProSyncQueue();
    }
    function processProSyncQueue() {
      if (proSyncInFlight || !proSyncQueue.length) return;
      proSyncInFlight = true;
      var item = proSyncQueue.shift();
      syncOneProPrice(item, function () {
        proSyncInFlight = false;
        processProSyncQueue();
      });
    }
    function syncOneProPrice(item, done) {
      var sectionEl = document.querySelector('[data-section-type="product"]');
      var sectionId = sectionEl ? sectionEl.getAttribute('data-section-id') : null;
      if (!sectionId) { done(); return; }
      var url = item.productUrl + '?variant=' + item.variantId + '&section_id=' + sectionId;
      var finished = false;
      function finish() { if (finished) return; finished = true; done(); }

      fetch(url).then(function (res) { return res.text(); }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.getElementById('product-price-' + item.productId);
        if (!fresh) { finish(); return; }

        var container = getProSyncContainer();
        container.innerHTML = fresh.innerHTML;
        container.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          if (oldScript.src) newScript.src = oldScript.src; else newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        var attempts = 0, maxAttempts = 20;
        var poll = setInterval(function () {
          attempts++;
          var priceEl = container.querySelector('.wpd-tax-excl-price');
          if (priceEl && priceEl.textContent && priceEl.textContent.trim()) {
            var textVal = priceEl.textContent || '';
            var num = parseFloat(textVal.replace(/[^\d,.-]/g, '').replace(',', '.'));
            if (num) { proPriceCache[item.variantId] = Math.round(num * 100); recalc(); }
            clearInterval(poll);
            finish();
          } else if (attempts >= maxAttempts) {
            clearInterval(poll);
            finish();
          }
        }, 300);
      }).catch(function () { finish(); });
    }

    // ---------------------------------------------------------------
    // Recalc
    // ---------------------------------------------------------------
    function recalc() {
      var rollsNeeded = 0, hoekpalen = 0, tussenpalen = 0, totalLength = 0;
      var gateActive = false, gateDoorItem = null, gatePostItem = null;

      if (state.mode === 'lopende') {
        totalLength = parseFloat(linearLengthInput.value) || 0;
        if (totalLength > 0) {
          rollsNeeded = Math.ceil(totalLength / active.rollLengthM);
          if (state.polesOn) {
            var corners = parseInt(linearCornersInput.value, 10) || 0;
            hoekpalen = corners + 2;
            var intervals = Math.ceil((totalLength - EPS) / state.spacing);
            tussenpalen = Math.max(0, intervals - 1);
          }
        }
        // Poort is enkel beschikbaar bij Rechthoek/Vrije vorm (nodig om een
        // zijde + positie te kunnen kiezen) — in deze modus dus nooit actief.
      } else {
        var eff = getEffectiveSegments();
        var gatePlacement = computeGatePlacement(eff.list, eff.closed);
        drawFence(eff.list, eff.closed, gatePlacement);
        var poleResult = computePolesForSegments(eff.list, eff.closed, state.spacing, gatePlacement);
        totalLength = poleResult.totalLength;
        if (totalLength > 0) {
          rollsNeeded = Math.ceil(totalLength / active.rollLengthM);
          if (state.polesOn) { hoekpalen = poleResult.hoekpalen; tussenpalen = poleResult.tussenpalen; }
        }
        if (gatePlacement) {
          gateActive = true;
          gateDoorItem = state.gateItem;
          // De paal-kost wordt pas meegeteld zodra de klant effectief
          // eik of kastanje gekozen heeft — voordien is gatePostItem null.
          gatePostItem = state.gatePost ? (state.gatePost === 'eik' ? active.paalEik : active.paalKastanje) : null;
        }
      }

      polesQuestion.hidden = totalLength <= 0;

      if (totalLength <= 0) {
        resultsEl.hidden = true;
        breakdownEl.innerHTML = '';
        addToCartBtn.disabled = true;
        lastCalc = null;
        return;
      }

      var supportCount = (state.polesOn && state.supportOn) ? hoekpalen : 0;

      var totalCents = rollsNeeded * active.fencePriceCents;
      if (state.polesOn) {
        totalCents += hoekpalen * active.hoekpaal.priceCents + tussenpalen * active.tussenpaal.priceCents + supportCount * active.versteviging.priceCents;
      }
      if (gateActive) {
        if (gateDoorItem) totalCents += gateDoorItem.priceCents;
        if (gatePostItem) totalCents += 2 * gatePostItem.priceCents;
      }

      lastCalc = {
        rollsNeeded: rollsNeeded, hoekpalen: hoekpalen, tussenpalen: tussenpalen, supportCount: supportCount,
        gateActive: gateActive, gateDoorItem: gateDoorItem, gatePostItem: gatePostItem, totalCents: totalCents
      };

      renderBreakdown();
      resultsEl.hidden = false;
      addToCartBtn.disabled = false;

      if (data.isProfessional) {
        requestProSync({ variantId: active.variantId, productUrl: active.fenceProductUrl, productId: active.fenceProductId });
        if (state.polesOn) {
          if (hoekpalen > 0) requestProSync(active.hoekpaal);
          if (tussenpalen > 0) requestProSync(active.tussenpaal);
          if (supportCount > 0) requestProSync(active.versteviging);
        }
        if (gateActive) {
          if (gateDoorItem) requestProSync(gateDoorItem);
          if (gatePostItem) requestProSync(gatePostItem);
        }
      }
    }

    function renderBreakdown() {
      breakdownEl.innerHTML = '';
      function addRow(container, labelText, qty, unitCents, titleText, strike) {
        var row = document.createElement('div');
        row.className = 'hek-calc__row' + (strike ? ' hek-calc__row--strike' : '');
        var left = titleText ? (qty + ' ' + (t.pieces || 'x') + ' ' + labelText + ' <span class="hek-calc__row-sub">(' + titleText + ')</span>') : (qty + ' ' + (t.pieces || 'x') + ' ' + labelText);
        row.innerHTML = '<span>' + left + '</span><strong>' + money(qty * (unitCents || 0)) + '</strong>';
        container.appendChild(row);
      }

      addRow(breakdownEl, t.rollsLabel, lastCalc.rollsNeeded, active.fencePriceCents, active.fenceTitle, data.isProfessional);
      if (state.polesOn) {
        if (lastCalc.hoekpalen > 0) addRow(breakdownEl, t.hoekpalenLabel, lastCalc.hoekpalen, active.hoekpaal.priceCents, active.hoekpaal.title, data.isProfessional);
        if (lastCalc.tussenpalen > 0) addRow(breakdownEl, t.tussenpalenLabel, lastCalc.tussenpalen, active.tussenpaal.priceCents, active.tussenpaal.title, data.isProfessional);
        if (lastCalc.supportCount > 0) addRow(breakdownEl, t.versteviLabel, lastCalc.supportCount, active.versteviging.priceCents, active.versteviging.title, data.isProfessional);
      }
      if (lastCalc.gateActive && lastCalc.gateDoorItem) addRow(breakdownEl, t.gateLineLabel, 1, lastCalc.gateDoorItem.priceCents, (lastCalc.gateDoorItem.fullTitle || lastCalc.gateDoorItem.title), data.isProfessional);
      if (lastCalc.gateActive && lastCalc.gatePostItem) addRow(breakdownEl, t.gatePostLineLabel, 2, lastCalc.gatePostItem.priceCents, lastCalc.gatePostItem.title, data.isProfessional);

      var totalRow = document.createElement('div');
      totalRow.className = 'hek-calc__row hek-calc__row--total' + (data.isProfessional ? ' hek-calc__row--strike' : '');
      totalRow.innerHTML = '<span>' + (t.totalLabel || '') + '</span><strong>' + money(lastCalc.totalCents) + '</strong>';
      breakdownEl.appendChild(totalRow);

      if (!data.isProfessional) { proBreakdownEl.hidden = true; return; }

      var neededIds = [active.variantId];
      if (state.polesOn) {
        if (lastCalc.hoekpalen > 0) neededIds.push(active.hoekpaal.variantId);
        if (lastCalc.tussenpalen > 0) neededIds.push(active.tussenpaal.variantId);
        if (lastCalc.supportCount > 0) neededIds.push(active.versteviging.variantId);
      }
      if (lastCalc.gateActive && lastCalc.gateDoorItem) neededIds.push(lastCalc.gateDoorItem.variantId);
      if (lastCalc.gateActive && lastCalc.gatePostItem) neededIds.push(lastCalc.gatePostItem.variantId);

      var allReady = neededIds.every(function (id) { return proPriceCache[id] != null; });
      if (!allReady) { proBreakdownEl.hidden = true; return; }

      proBreakdownEl.innerHTML = '';
      var proTitle = document.createElement('p');
      proTitle.className = 'hek-calc__row-group-title';
      proTitle.textContent = t.proGroupTitle || '';
      proBreakdownEl.appendChild(proTitle);

      var proTotalCents = 0;
      function addProRow(qty, variantId, labelText, titleText) {
        var unitCents = proPriceCache[variantId];
        proTotalCents += qty * unitCents;
        addRow(proBreakdownEl, labelText, qty, unitCents, titleText, false);
      }
      addProRow(lastCalc.rollsNeeded, active.variantId, t.rollsLabel, active.fenceTitle);
      if (state.polesOn) {
        if (lastCalc.hoekpalen > 0) addProRow(lastCalc.hoekpalen, active.hoekpaal.variantId, t.hoekpalenLabel, active.hoekpaal.title);
        if (lastCalc.tussenpalen > 0) addProRow(lastCalc.tussenpalen, active.tussenpaal.variantId, t.tussenpalenLabel, active.tussenpaal.title);
        if (lastCalc.supportCount > 0) addProRow(lastCalc.supportCount, active.versteviging.variantId, t.versteviLabel, active.versteviging.title);
      }
      if (lastCalc.gateActive && lastCalc.gateDoorItem) addProRow(1, lastCalc.gateDoorItem.variantId, t.gateLineLabel, (lastCalc.gateDoorItem.fullTitle || lastCalc.gateDoorItem.title));
      if (lastCalc.gateActive && lastCalc.gatePostItem) addProRow(2, lastCalc.gatePostItem.variantId, t.gatePostLineLabel, lastCalc.gatePostItem.title);

      var proTotalRow = document.createElement('div');
      proTotalRow.className = 'hek-calc__row hek-calc__row--total';
      proTotalRow.innerHTML = '<span>' + (t.totalProLabel || '') + '</span><strong>' + money(proTotalCents) + ' ' + (t.exclVat || '') + '</strong>';
      proBreakdownEl.appendChild(proTotalRow);

      proBreakdownEl.hidden = false;
    }

    function addToCart() {
      if (!lastCalc) return;
      var items = [{ id: active.variantId, quantity: lastCalc.rollsNeeded }];
      if (state.polesOn) {
        if (lastCalc.hoekpalen > 0) items.push({ id: active.hoekpaal.variantId, quantity: lastCalc.hoekpalen });
        if (lastCalc.tussenpalen > 0) items.push({ id: active.tussenpaal.variantId, quantity: lastCalc.tussenpalen });
        if (lastCalc.supportCount > 0) items.push({ id: active.versteviging.variantId, quantity: lastCalc.supportCount });
      }
      if (lastCalc.gateActive && lastCalc.gateDoorItem) items.push({ id: lastCalc.gateDoorItem.variantId, quantity: 1 });
      if (lastCalc.gateActive && lastCalc.gatePostItem) items.push({ id: lastCalc.gatePostItem.variantId, quantity: 2 });
      items = items.filter(function (item) { return item.quantity > 0 && item.id; });

      cartMsg.className = 'hek-calc__cart-msg';
      cartMsg.textContent = t.adding || '';
      addToCartBtn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { if (!res.ok) throw new Error('Cart add failed'); return res.json(); })
        .then(function () { cartMsg.textContent = t.added || ''; addToCartBtn.disabled = false; })
        .catch(function (err) {
          console.error(err);
          cartMsg.className = 'hek-calc__cart-msg hek-calc__cart-msg--error';
          cartMsg.textContent = t.error || '';
          addToCartBtn.disabled = false;
        });
    }
    addToCartBtn.addEventListener('click', addToCart);

    // ---------------------------------------------------------------
    // Info-knoppen (i): klik-to-toggle bovenop de bestaande hover, zodat
    // dit ook op mobiel/touch werkt (waar :hover niet betrouwbaar is).
    // ---------------------------------------------------------------
    root.querySelectorAll('.hek-calc__info-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wrap = btn.closest('.hek-calc__info-wrap');
        var wasOpen = wrap.classList.contains('is-open');
        root.querySelectorAll('.hek-calc__info-wrap.is-open').forEach(function (w) { w.classList.remove('is-open'); });
        if (!wasOpen) wrap.classList.add('is-open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) return;
      if (e.target.closest('.hek-calc__info-wrap')) return;
      root.querySelectorAll('.hek-calc__info-wrap.is-open').forEach(function (w) { w.classList.remove('is-open'); });
    });

    // ---------------------------------------------------------------
    // Init
    // ---------------------------------------------------------------
    addSegment();
  }

  return { init: init };
})();